import { initObservability } from '@cascade/react-dom/observability';
import { observability } from '#config/index.ts';

initObservability(observability);
